/* eslint-disable react/prop-types */
import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import formatPlanType from '../../utils/formatPlanType';

const DistributionFormModal = ({ open, planType, onCancel, onConfirm }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const formattedPlanType = formatPlanType(planType);

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullScreen={fullScreen}
      maxWidth="sm"
      fullWidth
      aria-labelledby="distribution-form-dialog-title"
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
        }
      }}
    >
      <DialogTitle
        id="distribution-form-dialog-title"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          pb: 2,
          backgroundColor: theme.palette.primary.main,
          color: 'white',
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 28 }} />
        <Typography variant="h6" component="span" fontWeight={600}>
          Important Notice
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pt: 3, pb: 2 }}>
        <DialogContentText
          sx={{
            fontSize: '1rem',
            color: 'text.primary',
            lineHeight: 1.6,
            mb: 2.5
          }}
        >
          This is the <strong>{formattedPlanType} Admin Distribution Form</strong>. You'll also need to request a distribution form directly from your investment provider to complete your distribution.
        </DialogContentText>

        <Box
          sx={{
            backgroundColor: 'rgba(211, 47, 47, 0.08)',
            borderLeft: '4px solid',
            borderColor: 'error.main',
            borderRadius: 1,
            p: 2,
            mt: 2
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: 'error.main',
              mb: 1
            }}
          >
            Signature Requirement
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
            Electronic signatures will not be accepted. A wet signature is required.
          </Typography>
        </Box>

        <Box
          sx={{
            backgroundColor: 'rgba(25, 118, 210, 0.08)',
            borderLeft: '4px solid',
            borderColor: 'primary.main',
            borderRadius: 1,
            p: 2,
            mt: 2
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: 'primary.main',
              mb: 1
            }}
          >
            Submission Instructions
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
            Once all forms are completed, please submit them together via fax, email, or mail. Sections A-D must be complete for processing.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, pt: 1, gap: 1.5 }}>
        <Button
          onClick={onCancel}
          variant="outlined"
          color="primary"
          sx={{
            minWidth: 100,
            fontWeight: 500,
            textTransform: 'none',
            borderRadius: 1.5
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          autoFocus
          sx={{
            minWidth: 180,
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: 1.5,
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4
            }
          }}
        >
          Acknowledged and Download
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DistributionFormModal;
